import {  fetchWrapper } from '@/_helpers';

export const fileApi = {
    getOrCreateTranscription: (data, queryString) => fetchWrapper.post(`file/transcriptions/get${queryString}`, data),
};
